import { IClubWithActiveCourseModel } from "@app/pages/clubs/models/club-with-active-course-model";
import { BookProgressModel } from "./book-progress-model";
import { ActivityVerbEnum } from "./enum/activity-verb-enum";
import { TokenModel } from "./token-model";

export class ActivitiesAggrigatorModel {
  id?: string;
  verb?: number;
  totalMarks?: number;

  // ? Who did this ?
  actor?: ActivitiesActorAndAffected;

  // ? Who is affected by this ?
  affectedUser?: ActivitiesActorAndAffected;

  // ? What is this work done on ?
  object?: ActivitiesObject;

  // ? What has the actor done ?
  inDirectObject?: ActivitiesObject;
  hasPhoto?: boolean;
  createdAt?: string;

  totalComments?: number;
  totalLikes?: number;
  userLiked?: boolean;

  carried?: CarriedModel;

  isSuggest?: boolean;
  suggestedClub?: IClubWithActiveCourseModel;

  userMarked?: boolean;
  userRestricted?: boolean;

  actualDate?: string;

  public static newItem(currentUser: TokenModel, res: BookProgressModel): ActivitiesAggrigatorModel {
    const x = new ActivitiesAggrigatorModel();
    x.createdAt = new Date().toString();
    x.verb = ActivityVerbEnum.ReadingProgressed;
    x.actor = new ActivitiesActorAndAffected();
    x.actor = {
      myFollowState: 0,
      id: currentUser?.userId,
      fullName: currentUser?.name,
      userName: currentUser?.userName
    };
    x.inDirectObject = new ActivitiesObject();
    x.inDirectObject = {
      data: {
        steps: res.steps,
        body: res.body,
      }
    }
    return x;
  }


}

export class ActivitiesActorAndAffected {
  id?: string;
  fullName?: string;
  type?: number;
  myFollowState?: number;
  userName?: string;
  hasPhoto?: boolean;
  hasWallpaper?: boolean;
  name?: string
}

export class ActivitiesObject {
  objectType?: number;
  objectId?: string;

  data?: any;
  hasPhoto?: boolean;
}

export class CarriedModel {
  objectType?: number;
  objectId?: string;

  data?: any;
}
